import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!measurementId) return;

    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    if (!window.gtag) {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }

    const existingScript = document.querySelector(`script[data-ga-id="${measurementId}"]`);
    if (!existingScript) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.setAttribute('data-ga-id', measurementId);
      document.head.appendChild(script);
    }

    window.gtag('js', new Date());
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'granted',
    });
    window.gtag('config', measurementId, {
      send_page_view: false,
      cookie_flags: 'SameSite=Lax;Secure',
    });
  }, []);

  useEffect(() => {
    if (!measurementId || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search]);

  return null;
}

export default GoogleAnalyticsTracker;
